export const historyChangesModalName = 'history-changes';
